import { useMemo } from 'react';
import { useMenuItems, MenuSection } from './useMenuItems';

/** Map filtered Distill section titles to GolfOS-native group labels */
function remapGolfOSSectionTitle(title: string): string {
  const t = title.trim();
  if (t === 'Main') return 'Overview';
  if (t.includes('GOLF') || t.includes('AMENITY')) return 'Course & amenities';
  if (t.includes('Service & Field') || t.includes('Field Dispatch')) return 'Daily operations';
  if (t.includes('Course & Community') || t.includes('Community Assets')) return 'Fleet & property';
  if (t.includes('Configuration')) return 'Administration';
  return t;
}

export const useGolfOSMenuItems = (): MenuSection[] => {
  const sections = useMenuItems();
  return useMemo(
    () =>
      sections.map(s => ({
        ...s,
        title: remapGolfOSSectionTitle(s.title),
      })),
    [sections],
  );
};
